import { BrowserModule } from '@angular/platform-browser';
import { ErrorHandler, NgModule, CUSTOM_ELEMENTS_SCHEMA, APP_INITIALIZER } from '@angular/core';
import { IonicApp, IonicErrorHandler, IonicModule } from 'ionic-angular';
import { AppComponent } from './app.component';
import { StatusBar } from '@ionic-native/status-bar';
import { SplashScreen } from '@ionic-native/splash-screen';
import { ApiProvider } from '../providers/api/api';
import { NotificationProvider } from '../providers/notification/notification';
import { TimeHelperProvider } from '../providers/time-helper/time-helper';
import { EmployeeProvider } from '../providers/employee/employee';
import { VersionProvider } from '../providers/version/version';
import { IonicStorageModule, Storage } from '@ionic/storage';
import { instantiateCompanyService, CompanyProvider } from '../providers/company/company';
import { ScheduleProvider } from '../providers/schedule/schedule';
import { WorkTableProvider } from '../providers/work-table/work-table';
import { ScheduleEventProvider } from '../providers/schedule-event/schedule-event';
import { FullCalendarModule } from 'ng-fullcalendar';
import { CommonModule } from "@angular/common";
import { UserEventsProvider } from '../providers/user-events/user-events';
import { HTTP_INTERCEPTORS, HttpClientModule, HttpClient } from "@angular/common/http";
import { Printer } from '@ionic-native/printer';
import { ApiInterceptor } from "../interceptors/ApiInterceptor";
import { LoginModalComponent } from '../components/login-modal/login-modal';
import { IonNumericKeyboard } from '../components/ion-numeric-keyboard';
import { PipesModule } from '../pipes/pipes.module';

export function provideStorage() {
	//@ts-ignore
	return new Storage({
		name: '__mydb',
		storeName: '__app_db',
		driverOrder: ['localstorage', 'indexeddb', 'sqlite', 'websql']
	});
}

@NgModule({
	declarations: [
		AppComponent,
		IonNumericKeyboard,
		LoginModalComponent
	],
	imports: [
		HttpClientModule,
		BrowserModule,
		FullCalendarModule,
		PipesModule,
		CommonModule,
		IonicModule.forRoot(AppComponent, {
			mode:"md",
			scrollPadding: false,
			scrollAssist: true,
			autoFocusAssist: false
		}),
		IonicStorageModule.forRoot()
	],
	bootstrap: [IonicApp],
	schemas: [CUSTOM_ELEMENTS_SCHEMA],
	entryComponents: [
		AppComponent,
		LoginModalComponent
	],
	providers: [
		StatusBar,
		SplashScreen,
		ApiProvider,
		NotificationProvider,
		TimeHelperProvider,
		EmployeeProvider,
		CompanyProvider,
		VersionProvider,
		ScheduleProvider,
		WorkTableProvider,
		ScheduleEventProvider,
		UserEventsProvider,
		Printer,
		{ provide: ErrorHandler, useClass: IonicErrorHandler },
		{ provide: Storage, useFactory: provideStorage },
		{ provide: HTTP_INTERCEPTORS, useClass: ApiInterceptor, multi: true },
		{ provide: APP_INITIALIZER, useFactory: instantiateCompanyService, useExisting: HttpClient, deps: [CompanyProvider], multi: true },
	]
})

export class AppModule {
}



// WEBPACK FOOTER //
// ./src/app/app.module.ts